module.exports = {"620825001":"水洛街道","620825100":"水洛镇","620825101":"南湖镇","620825102":"朱店镇","620825103":"万泉镇","620825104":"韩店镇","620825105":"卧龙镇","620825106":"阳川镇","620825107":"盘安镇","620825108":"大庄镇","620825109":"通化镇","620825110":"永宁镇","620825111":"良邑镇","620825112":"岳堡镇","620825113":"柳梁镇","620825114":"南坪镇","620825201":"杨河乡","620825202":"赵墩乡","620825215":"郑河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620825.json
// module id = 3068
// module chunks = 0